import React from 'react';
import { useNavigate } from 'react-router-dom';
import './QuickAccessMenu.css'; // Optional: add your styling here

export default function QuickAccessMenu() {
  const navigate = useNavigate();

  const menuItems = [
    { id: 1, title: 'Practice Questions', path: '/users/practice', icon: '📝' },
    { id: 2, title: 'Quiz Tests', path: '/users/quiz', icon: '⏱️' },
    { id: 3, title: 'Mock Tests', path: '/users/mock-tests', icon: '🎯' },
    { id: 4, title: 'Typing Tests', path: '/users/typing', icon: '⌨️' },
    { id: 5, title: 'PDF Contents', path: '/users/pdfs', icon: '📄' },
    { id: 6, title: 'Cogni Reader', path: '/users/cogni-reader', icon: '🧠' },
  ];

  return (
    <div className="quick-access-container" style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '20px', color: '#0f172a' }}>Quick Access</h2>
      
      <div 
        className="quick-access-grid" 
        style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
          gap: '20px' 
        }}
      >
        {menuItems.map((item) => (
          <div 
            key={item.id} 
            onClick={() => navigate(item.path)}
            className="menu-card"
            style={{
              padding: '30px 20px',
              backgroundColor: '#fff',
              borderRadius: '12px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
              cursor: 'pointer',
              textAlign: 'center',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              border: '1px solid #e2e8f0'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <div style={{ fontSize: '2.5rem', marginBottom: '10px' }}>{item.icon}</div>
            <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#334155' }}>
              {item.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
}